export var externalConfig = {
  value: {
    apiVersion: undefined,
    appURL: undefined,
    apiURL: undefined,
  },
};

export default {
  isApiMock: process.env.VUE_APP_MOCK === "true",
  isAppInstalled() {
    return localStorage.getItem("isInstalled");
  },
  setIsAppInstalled(isInstalled: boolean) {
    localStorage.setItem("isInstalled", isInstalled ? "true" : "false")
  },

  isWakeLockAPICompatible() {
    return localStorage.getItem("isWakeLockAPICompatible") !== null && localStorage.getItem("isWakeLockAPICompatible") === 'true';
  },
  setWakeLockAPICompatible(isCompatible: boolean) {
    localStorage.setItem("isWakeLockAPICompatible", isCompatible ? "true" : "false")
  },
  isNetWorkAPICompatible() {
    return localStorage.getItem("isNetWorkAPICompatible") !== null && localStorage.getItem("isNetWorkAPICompatible") === 'true';
  },
  setNetWorkAPICompatible(isCompatible: boolean) {
    localStorage.setItem("isNetWorkAPICompatible", isCompatible ? "true" : "false")
  },
  getCouchDbServerUrl() {
    return process.env.VUE_APP_COUCHDB_SUB_SERVER_URL;
  },

  getVersionAppMobi() {
    return localStorage.getItem('versionAppMobi');
  },

  setVersionAppMobi(version: string) {
    localStorage.setItem('versionAppMobi', "");
    localStorage.setItem('versionAppMobi', version);
  },


  getNewVersionAppMobi() {
    return localStorage.getItem('newVersionAppMobi');
  },

  setNewVersionAppMobi(version: string) {
    localStorage.setItem('newVersionAppMobi', "");
    localStorage.setItem('newVersionAppMobi', version);
  },
  getNomDossierMobi() {
    return localStorage.getItem('nomDossierMobi');
  },
  setNomDossierMobi(nomDossier: string) {
    localStorage.setItem('nomDossierMobi', "");
    localStorage.setItem('nomDossierMobi', nomDossier);
  },
  setInfoDossier(infoDossier:any){
    localStorage.setItem("infoDossier",JSON.stringify(infoDossier))
  },
  getInfoDossier():any{
    JSON.parse(localStorage.getItem("infoDossier")||'{}');
  },
  getRemoteDbURL() {
    return this.getCouchDbServerUrl()+"/" + this.getCluster() + "/" + this.getRemoteDBName() ;
  },
  clearAll() {

    localStorage.clear();
    //@ts-ignore
    window.indexedDB.databases().then((r: any) => {
      for (var i = 0; i < r.length; i++) window.indexedDB.deleteDatabase(r[i].name);
    });
  },
  getDossier() {
    return localStorage.getItem("dossierId") || "";
  },
  setDossier(dossier: string) {
    localStorage.setItem("dossierId", dossier);
  },

  getRemoteDBName() {
    return "inoe-" + this.getDossier() + "-" + this.getUsername().toLowerCase();
  },
  getRemoteDBUserName() {
    return "uinoe-" + this.getDossier();
  },
  getRemoteDBPassword(): string {
    return this.getAccessKey();
  },
  getApiVersion(): string {
    return (
      externalConfig.value.apiVersion || process.env.VUE_APP_API_VERSION || ""
    );
  },
  getDateRange() {
    return localStorage.getItem("dateRange")
  },
  setDateRange(dateRange: Array<number>) {
    localStorage.setItem("dateRange", dateRange[0] + "#" + dateRange[1])
  },
  getAccessKey(): string {
    return localStorage.getItem("magickey") || localStorage.getItem("accesskey") || "";
  },
  setAccessKey(value: string) {
    localStorage.setItem("accesskey", value);
  },
  getUsername(): string {
    return localStorage.getItem("username") || "";
  },
  getCluster():string{
    return localStorage.getItem("cluster") || "c1";
  },
  setCluster(value:string){
    localStorage.setItem('cluster',value);
  },
  setUsername(value: string) {
    localStorage.setItem("username", value);
  },
  getSelectedPageSize(): number {
    let s = localStorage.getItem("selectedPageSize");
    if (s !== null)
      return Number.parseInt(s);
    else return 9999;
  },
  setSelectedPageSize(value: number) {
    localStorage.setItem("selectedPageSize", value.toString());
  },
  getAuthorisation():string|null{
    return process.env.VUE_APP_AUTHORIZATION || localStorage.getItem("authorization");
  },
  isAllowAllPin(){
    return this.getAuthorisation()!=null;
  },
  isPilote(){
    return process.env.BASE_URL!=="/";
  },
  getRemoteConf():any|null{
    let json=localStorage.getItem("conf")||"";
    return JSON.parse(json);
  },
  getUserId(){
    let user=this.getRemoteConf().users.list.find((u:any)=>u.login===this.getUsername());
    let userId=parseInt(user._id.replace("UtilisateurDocument_",""))
    return userId;
  },
  setRemoteConf(conf:any){    
   localStorage.setItem("conf",JSON.stringify(conf));
  },
  getVersion(){
      let json=localStorage.getItem("version")||"{cluster:'c1'}"
      return JSON.parse(json);
  },
   getUpgrade(){
      let json=localStorage.getItem("upgrade")||"{}"
      return JSON.parse(json);
  }, 
  isUpgrading(){
   return this.getUpgrade().cluster && this.getCluster()!==this.getUpgrade().cluster;
  },

  getClusterMobiURL(): string {
   return "/info/"; 
  },

};
